exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#loading{background:rgba(255,255,255,.6);position:fixed;height:100vh;width:100vw;z-index:10010;top:0;left:0;text-align:center\n}\n#loading i{Position:absolute;Top:50%;Transform:translateY(-50%)\n}", ""]);

// exports
